"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfflinePlaygroundIdentity = void 0;
var useOfflinePlaygroundIdentity = function () {
    return {
        create: function (_a) {
            var appID = _a.appID, siteID = _a.siteID;
            return {
                appID: appID,
                siteID: siteID,
                type: 'offlinePlayground',
            };
        },
    };
};
exports.useOfflinePlaygroundIdentity = useOfflinePlaygroundIdentity;
//# sourceMappingURL=useOfflinePlaygroundIdentity.js.map